<template>
  <div class="w-100 pb-5">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>
            Livsmiljöer
          </h1>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 9 : 12">
              <p class="body-3">
                Livsmiljön för en växt eller ett djur är den miljö där den kan
                leva. Sjögräsets livsmiljö utgörs exempelvis av grunda
                mjukbottnar där ljuset når ner. Många rörliga arter, som fisk,
                utnyttjar olika livsmiljöer under olika delar av livet. För att
                bevara havslevande arter måste vi skydda deras livsmiljöer. Men
                miljöer som är livsviktiga för många havslevande arter är också
                attraktiva för oss människor.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="justify-center">
        <v-col cols="12" class="d-flex justify-space-around flex-wrap">
          <v-btn
            class="mt-4"
            rounded
            color="primary"
            dark
            v-for="section in sections"
            :key="section.id"
            @click="
              $router.push({
                name: section.url
              })
            "
          >
            {{ section.heading }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12"
          v-for="section in sections"
          :key="section.id"
        >
          <v-card :id="section.url">
            <v-img
              min-height="300"
              :src="$_getImage(section.image)"
              height="200px"
            ></v-img>

            <v-card-title>
              {{ section.heading }}
            </v-card-title>

            <v-card-text class="subtitle-1">
              {{ section.text }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary darken-2"
                ripple
                text
                @click="
                  $router.push({
                    name: section.url
                  })
                "
              >
                Läs
                <v-icon right>
                  mdi-arrow-right
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'

export default {
  name: 'Livsmiljoer',
  metaInfo: {
    title: 'Livsmiljöer'
  },
  mixins: [Setup, Misc],
  computed: {},
  methods: {
    // selectSection(window, selectedEnv) {
    //   this.sampleSize = 4
    //   this.window = window
    //   this.selectedEnv = selectedEnv
    // }
  },
  data() {
    return {
      sections: [
        {
          id: 5,
          heading: 'Grunda klipp- och stenbottnar',
          text:
            'Från ytan ner till ungefär en meters djup växer fintrådiga grönalger på sommaren. Djupare finns ett bälte av flerårig tång som når ned till mer än tio meters djup i ytterskärgården. I Bottenviken saknas tången, där breder grönalgerna ut sig nedåt istället.',
          url: 'grunda-klipp-och-stenbottnar',
          image: '2442'
        },
        {
          id: 2,
          heading: 'Djupa klipp- och stenbottnar',
          text:
            'Djupare ned på klippbottnarna, under grön- och brunalgsbältena, breder rödalgerna ut sig. Det är inte mycket ljus som når hit men rödalgerna kan utnyttja det lilla som finns. Ännu djupare ned, dit ljuset inte når, tar djuren över.',
          url: 'djupa-klipp-och-stenbottnar',
          image: '2010'
        },
        {
          id: 1,
          heading: 'Grunda mjuka bottnar',
          text:
            'Vid de grunda mjuka bottnarna är vattnet ofta mer stillastående än ute i fjärdar och öppet hav. Öar, uddar och trösklar gör vattenutbytet och vågrörelserna mindre, vilket ger varmare vatten. Här breder vattenväxter och snärjtång ut sig i täta ängar. Längst in i viken står ofta vassen tät. ',
          url: 'grunda-mjuka-bottnar',
          image: '6530'
        },
        {
          id: 4,
          heading: 'Djupa mjuka bottnar',
          text:
            'Från drygt 20 meters djup och ända ned i de djupaste mörka hålorna, ligger ett tjockt lager av slam som en slöja över botten och suddar ut konturen av berg och stenar. På dessa väldiga lerslätter lever ett unikt mjukbottensamhälle bestående av olika smådjur. ',
          url: 'djupa-mjuka-bottnar',
          image: '2557'
        },
        {
          id: 3,
          heading: 'Det fria vattnet',
          text:
            'Ute till havs, i det fria vattnet, är miljöförhållandena ganska lika överallt. Därför är mångfalden av större växter och djur lägre här än den är på mjuk- och hårdbottnar. I vattnet närmast ytan lever mängder av olika arter växt- och djurplankton. ',
          url: 'det-fria-vattnet',
          image: '4288'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2.125rem !important;
  font-weight: 400;
}
</style>
